import type { IDesignImageThumb } from '@/common/interfaces/cart.interface';

/**
 * When primary and secondary design thumbnails share the same URL, keep one design slot.
 */
export const dedupeIdenticalDesignImageThumbnails = (
  images: IDesignImageThumb[]
): IDesignImageThumb[] => {
  const primaryIdx = images.findIndex((i) => i.type === 'design_image_primary');
  const secondaryIdx = images.findIndex((i) => i.type === 'design_image_secondary');
  if (primaryIdx < 0 || secondaryIdx < 0) {
    return images;
  }
  const primary = images[primaryIdx];
  const secondary = images[secondaryIdx];
  if (!primary.src || primary.src !== secondary.src) {
    return images;
  }
  const next = images.filter((_, idx) => idx !== secondaryIdx);
  const newPrimaryIdx = next.findIndex((i) => i.type === 'design_image_primary');
  if (newPrimaryIdx >= 0) {
    next[newPrimaryIdx] = {
      ...next[newPrimaryIdx],
      selected: Boolean(primary.selected || secondary.selected),
    };
  }
  return next;
};
